import { TErrorModel } from './type'

class ModelError implements Partial<TErrorModel> {
    public readonly data?: unknown
    public readonly error?: {
        details?: {
            [key: string]: any
        }
        message?: string
        status?: number
    }

    constructor(data: ModelError) {
        Object.assign(this, data)
    }
}

export default ModelError
